import getLang from 'I18n/utils/getLang';
import styled from 'styled-components';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Image } from 'foundations-components/transitional/components/Image';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { ILLUSTRATION_OVERRIDES, IMAGE_BACKGROUND_OVERRIDES, LOCALIZED_IMAGE_OVERRIDES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const ImageWrapper = styled.div.withConfig({
  displayName: "UpgradePopoverImage__ImageWrapper",
  componentId: "sc-14qfril-0"
})(({
  upgradeKey,
  theme
}) => ({
  textAlign: 'center',
  width: '100%',
  backgroundColor: upgradeKey in IMAGE_BACKGROUND_OVERRIDES ? IMAGE_BACKGROUND_OVERRIDES[upgradeKey] : theme.color['fill-info-subtle'],
  marginBlockEnd: theme.space['400']
}));
export const imageHosts = {
  DE: 'https://www.hubspot.de',
  EN: 'https://www.hubspot.com',
  ES: 'https://www.hubspot.es',
  FR: 'https://www.hubspot.fr',
  JA: 'https://www.hubspot.jp',
  PT: 'https://br.hubspot.com'
};
const getLocalizedImage = upgradeKey => {
  const lang = getLang().toUpperCase();
  let imageHost = imageHosts['EN'];
  if (Object.keys(imageHosts).includes(lang)) {
    imageHost = imageHosts[lang];
  }
  const prefix = `${imageHost}/hs-fs/hubfs/UpgradePopover/`;
  return `${prefix}${LOCALIZED_IMAGE_OVERRIDES[upgradeKey]}_${lang}.png`;
};
const getImage = ({
  logoKey,
  upgradeConfig,
  upgradeKey
}) => {
  if (logoKey) {
    return /*#__PURE__*/_jsx(Logo, {
      name: logoKey,
      height: 115
    });
  }
  if (upgradeKey in ILLUSTRATION_OVERRIDES) return /*#__PURE__*/_jsx(Illustration, {
    name: ILLUSTRATION_OVERRIDES[upgradeKey],
    height: 115,
    paddingBlock: "200"
  });
  if (upgradeKey in LOCALIZED_IMAGE_OVERRIDES) {
    return /*#__PURE__*/_jsx(Image, {
      src: getLocalizedImage(upgradeKey),
      role: "img",
      margin: "0"
    });
  }
  const {
    visualKey,
    visualType
  } = upgradeConfig || {};
  if (upgradeConfig && visualKey && visualType === 'illustration') {
    return /*#__PURE__*/_jsx(Illustration, {
      name: visualKey,
      height: 115,
      paddingBlock: "200"
    });
  }
  return;
};
const UpgradePopoverImage = ({
  logoKey,
  upgradeConfig
}) => upgradeConfig ? /*#__PURE__*/_jsx(ImageWrapper, {
  upgradeKey: upgradeConfig.upgradeKey,
  children: getImage({
    logoKey,
    upgradeConfig,
    upgradeKey: upgradeConfig.upgradeKey
  })
}) : null;
export default UpgradePopoverImage;